import { ImagePanelFeatureType } from '@/types';

const ADJUST_BASE_TRACK: { [key: string]: number } = {
    id: 4,
    func: 62,
};

const ADJUST_ELIMINATE_TRACK: { [key: string]: number } = {
    id: 4,
    func: 72,
    penSize: 6,
};

const ADJUST_AI_ELIMINATE_TRACK: { [key: string]: number } = {
    id: 4,
    func: 71,
    penSize: 6,
    brush: 8,
    brush_draw: 54,
    box: 9,
    box_draw: 56,
    lasso: 10,
    lasso_draw: 57,
    text: 58,
    watermark: 59,
    passerby: 78,
    glasses: 79,
    glare: 80,
};

const ADJUST_LIGHT_TRACK: { [key: string]: number } = {
    id: 4,
    func: 63,
};
const ADJUST_PARTICULARS_TRACK: { [key: string]: number } = {
    id: 4,
    func: 65,
};
const ADJUST_COLOR_TRACK: { [key: string]: number } = {
    id: 4,
    func: 64,
};
const ADJUST_POSTERIZE_TRACK: { [key: string]: number } = {
    id: 4,
    func: 66,
};
const ADJUST_HSL_TRACK: { [key: string]: number } = {
    id: 4,
    func: 67,
};

export const TRACK_CONFIG: { [key: string]: any } = {
    [ImagePanelFeatureType.ADJUST_BASE]: ADJUST_BASE_TRACK,
    [ImagePanelFeatureType.ADJUST_LIGHT]: ADJUST_LIGHT_TRACK,
    [ImagePanelFeatureType.ADJUST_COLOR]: ADJUST_COLOR_TRACK,
    [ImagePanelFeatureType.ADJUST_POSTERIZE]: ADJUST_POSTERIZE_TRACK,
    [ImagePanelFeatureType.ADJUST_HSL]: ADJUST_HSL_TRACK,
    [ImagePanelFeatureType.ADJUST_PARTICULARS]: ADJUST_PARTICULARS_TRACK,
    [ImagePanelFeatureType.ADJUST_ELIMINATE]: ADJUST_ELIMINATE_TRACK,
    [ImagePanelFeatureType.ADJUST_AI_ELIMINATE]: ADJUST_AI_ELIMINATE_TRACK,
};
